"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chineseToSlug = chineseToSlug;
exports.generateUniqueSlug = generateUniqueSlug;
const pinyin_pro_1 = require("pinyin-pro");
const MAX_SLUG_LENGTH = 64;
function chineseToSlug(chineseName) {
    if (!chineseName || !chineseName.trim()) {
        return '';
    }
    const pinyinArray = (0, pinyin_pro_1.pinyin)(chineseName, {
        type: 'array',
        toneType: 'none',
        v: true,
    });
    let slug = pinyinArray
        .join('-')
        .toLowerCase()
        .replace(/[^\w-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
    if (slug.length > MAX_SLUG_LENGTH) {
        slug = slug.substring(0, MAX_SLUG_LENGTH);
        slug = slug.replace(/-+$/g, '');
    }
    return slug;
}
function generateUniqueSlug(name, existingSlugs) {
    const baseSlug = chineseToSlug(name);
    if (!baseSlug) {
        return '';
    }
    if (!existingSlugs.includes(baseSlug)) {
        return baseSlug;
    }
    let counter = 1;
    while (existingSlugs.includes(`${baseSlug}-${counter}`)) {
        counter++;
    }
    return `${baseSlug}-${counter}`;
}
//# sourceMappingURL=slug-generator.js.map